import React from "react";
import { Box } from "@mui/material";
import LargeTextField from "../LargeTextField";

const RKKDtCtTab = ({ data, onUpdate }) => {
  const dtCt = data.dtCt || {};

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", paddingBottom: "20px" }}>
      <LargeTextField
        label="Комментарии по дебиторам, покупателям:"
        value={dtCt.debitorsComment || ""}
        onChange={(v) => onUpdate("dtCt.debitorsComment", v)}
        minRows={4}
      />
      <LargeTextField
        label="Комментарии по кредиторам, поставщикам:"
        value={dtCt.creditorsComment || ""}
        onChange={(v) => onUpdate("dtCt.creditorsComment", v)}
        minRows={4}
      />
    </Box>
  );
};

export default RKKDtCtTab;
